export default "__VITE_ASSET__j0Tf6rjx__"